import React, { Component } from 'react';
import logo from './white_dove_big.png';
import './styles/Login.css';
import { CCOButton } from './util/Components.js';
import { FormControl, Alert, Collapse, Fade } from 'react-bootstrap';
import moment from 'moment';
import { update } from './util/Utility';
import { BeatLoader } from 'react-spinners';
import firebaseLocal from 'firebase';


class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      mode: 0,
      upalert: false,
      emailAlert: false,
      email: "",
      password: "",
      password2: "",
      name: "",
      invalidLoginAlert: false,
      accountPendingAlert: false,
      passwordMismatchAlert: false,
      emptyAlert: false,
      networkAlert: false,
      resetEmailSent: false,
      verificationEmailSent: false,
      nameAlert: false,
      loading: false,
      passwordAlert: false
    };

    this.needsSendUserData = false;
  }

  componentWillReceiveProps(props) {

    if (props.user && this.needsSendUserData) {
      console.log("Pushing new leader");
      update('leaders/' + window.firebase.auth().currentUser.uid, this, {
        email: this.state.email,
        name: this.state.name
      });
      this.needsSendUserData = false;
    }

    if (props.in === false) {
      this.setState({mode: 0, email: "", password: ""});
      this.handleAlertDismiss();
    }
  }

  requestClicked() {

    var parent = this;
    var email = this.state.email;

    window.base.push('pending_users', {
      data: {email: email, date: moment().unix()},
      then(err) {
        if (!err) {
          parent.setState({mode: 3});
        }
        else {
          parent.setState({networkAlert: true});
        }
      }
    });
  }

  validateEmail(email) {
    var re = /^.+@.+\..{2,3}$/;
    return re.test(email);
  }

  nextButtonPressed() {
    if (!this.validateEmail(this.state.email)) {
      this.setState({emailAlert: true});
    }
    else {

      var email = this.state.email;
      var parent = this;

      this.setState({loading: true});

      fetch('https://us-central1-ccoapp.cloudfunctions.net/get_user_status', {method: 'post', body: email}).then(response => {
        response.text().then(status => {
          console.log(status);
          if (status === 'active') {
            parent.setState({mode: 1, loading: false});
          } else if (status === 'approved') {
            parent.setState({mode: 4, loading: false});
          } else if (status === 'pending') {
            parent.setState({accountPendingAlert: true, loading: false});
          } else if (status === 'n/a') {
            parent.setState({mode: 2, loading: false});
          } else {
            console.log("Unkown status: " + status);
          }
        });
      }).catch(error => {
        console.warn(error);
        parent.setState({networkAlert: true});
      });

    }
  }

  loginClicked() {
    if (this.state.email === "" || this.state.password === "") {
      this.setState({upalert: true});
    }
    else {
      var email = this.state.email;
      var password = this.state.password;

      this.setState({loading: true});

      window.firebase.auth().signInWithEmailAndPassword(email, password).then(() => this.setState({loading: false})).catch(() => this.setState({invalidLoginAlert: true, loading: false}));
    }
  }

  createAccount() {
    let bad = false;

    if (this.state.password === "" || this.state.password2 === "" || this.state.name === "") {
      this.setState({emptyAlert: true});
      return;
    }

    if (this.state.name.split(" ").length < 2) {
      this.setState({nameAlert: true});
      bad = true;
    }
    if (this.state.password !== this.state.password2) {
      this.setState({passwordMismatchAlert: true});
      bad = true;
    }

    if (!bad) {

      var email = this.state.email;
      var password = this.state.password;

      this.needsSendUserData = true;

      window.firebase.auth().createUserWithEmailAndPassword(email, password).then(() => {
        let user = window.firebase.auth().currentUser;
        user.updateProfile({displayName: this.state.name}).then(() => {
          user.sendEmailVerification();
        });
      }).catch(error => {
        console.warn(error);
        if (error.code === "auth/weak-password") {
          this.setState({passwordAlert: true});
        } else {
          this.setState({networkAlert: true});
        }
      });
    }
  }

  handleAlertDismiss() {
    let updateObj = {};
    Object.keys(this.state).forEach(item => {
      if (item.toLowerCase().indexOf("alert") !== -1) {
        updateObj[item] = false;
      }
    });
    this.setState(updateObj);
  }

  handlePasswordChange(e) {
    this.setState({password: e.target.value, upalert: false, invalidLoginAlert: false, resetEmailSent: false});
  }

  handlePassword2Change(e) {
    this.setState({password2: e.target.value});
  }

  handleEmailChange(e) {
    this.setState({email: e.target.value, emailAlert: false, accountPendingAlert: false, invalidLoginAlert: false});
  }

  handleNameChange(e) {
    this.setState({name: e.target.value});
  }

  forgotPassword() {
    window.firebase.auth().sendPasswordResetEmail(this.state.email).then(() => this.setState({resetEmailSent: true})).catch(() => this.setState({networkAlert: true}));
  }

  resendEmail() {
    this.props.user.sendEmailVerification().then(() => this.setState({verificationEmailSent: true}));
  }

  check() {
    const credential = firebaseLocal.auth.EmailAuthProvider.credential(
      this.props.user.email,
      this.state.password
    );
    this.props.user.reauthenticateWithCredential(credential).then(function() {
      console.log("Reauthenticated successfully")
      location.reload();
    }).catch(function(error) {
      console.error(error);
    });
  }

  render() {

    let user = window.firebase.auth().currentUser;

    let formStyle = {
      top: this.props.mobile ? 150 : 350,
      width: Math.min(window.innerWidth - 20, 300),
      position: 'absolute',
      backgroundColor: '#99000B'
    }

    formStyle.left = (window.innerWidth - formStyle.width) / 2;

    return (
      <div className="Login" style={{height: Math.max(window.innerHeight, formStyle.top + 350)}}>
        <center>
          <img src={logo} style={{width: this.props.mobile ? 100 : 200, height: this.props.mobile ? 100 : 200, marginTop: 30}} />
          {!this.props.mobile && <h1 className="NameCenter" style={{fontWeight: '400', fontSize: 50}}>Calvary Chapel Orlando</h1>}

          <Fade in={this.state.mode === 3} unmountOnExit={true}><div style={formStyle}>
            <p>Thanks for signing up!  If you are approved, you will recieve an email within a few days with instructions to access the system.  We look forward to having you connect to the people in our congregation through the app.</p>
            <CCOButton type="white" text={'Back to Login'} onClick={() => this.setState({mode: 0})} />
          </div></Fade>

          <Fade in={this.state.mode === 2 && !user} unmountOnExit={true}><div style={formStyle}>

            <p>You do not appear to have an account yet, click below to request one.</p>

            <CCOAlert context={this} value="networkAlert" type="danger" title="Network Error" content="Could not access the server right now, please try again later." />

            <CCOButton type="white" text={'Request an Account'} onClick={this.requestClicked.bind(this)} />

            <div style={{height: 100}} />
          </div></Fade>

          <Fade in={this.state.mode === 4 && !user} unmountOnExit={true}><div style={formStyle}>
            <h4>Finish Creating Account</h4>

            <form onSubmit={evt => {
              this.createAccount();
              evt.preventDefault();
            }}>
              <FormControl type="text" label="Name" placeholder="Full Name" onChange={this.handleNameChange.bind(this)}/><div style={{height: 10}} />

              <FormControl type="password" label="Password" placeholder="Enter New Password" onChange={this.handlePasswordChange.bind(this)}/><div style={{height: 10}} />

              <FormControl type="password" label="Repeat Password" placeholder="Repeat Password" onChange={this.handlePassword2Change.bind(this)}/>

              <CCOAlert context={this} value="passwordMismatchAlert" type="warning" title="Passwords Do Not Match" content="Please check to make sure the passwords you entered are the same." />

              <CCOAlert context={this} value="emptyAlert" type="warning" title="Blank Fields" content="Please enter your full name and create a password." />

              <CCOAlert context={this} value="nameAlert" type="warning" title="Please Enter Full Name" content="Please enter both your first and last name." />

              <CCOAlert context={this} value="passwordAlert" type="warning" title="Insecure Password" content="Passwords must be at least 6 characters long" />

              <br />

              <CCOButton type="white" text={'Create Account'} />
            </form>

          </div></Fade>

          <Fade in={(this.state.mode === 0 || this.state.mode === 1) && !user} unmountOnExit={true}><div style={formStyle}>

            <form onSubmit={evt => {
              if (this.state.mode === 0)
                this.nextButtonPressed()
              else
                this.loginClicked()
              evt.preventDefault();
            }}>
              <FormControl id="formControlsEmail" type="text" ref="email" label="Email" placeholder="Email" onChange={this.handleEmailChange.bind(this)}/>

              <CCOAlert context={this} value="emailAlert" type="danger" title="Invalid Email" content="Please provide a valid email" />

              <Collapse in={this.state.mode === 1}><div>
                <div style={{height: 20}} />
                <FormControl id="formControlsPassword" type="password" label="Password" placeholder="Password" onChange={this.handlePasswordChange.bind(this)}/>
              </div></Collapse>

              <CCOAlert context={this} value="invalidLoginAlert" type="danger" title="Email or Password Incorrect" content="Please make sure you typed your email and password correctly." />

              <CCOAlert context={this} value="accountPendingAlert" type="info" title="Account Pending" content="Your account is waiting to be approved; you will get an email notification when you are able to begin using this service." />

              <CCOAlert context={this} value="upalert" type="warning" title="Blank Fields" content="Please fill in both the Email and Password fields before logging in." />

              <CCOAlert context={this} value="resetEmailSent" type="info" title="Reset Password Email Sent" content="Go ahead and reset your password, then come back here to log in." />

              <div style={{height: 15}} />

              {this.state.loading ? <BeatLoader loading size={10} color="white" /> : <CCOButton type="white" text={this.state.mode === 0 ? 'Next' : 'Login'} />}
            </form>

            {this.state.mode === 1 && <button className="ResetButton" onClick={this.forgotPassword.bind(this)}>Forgot Password</button>}
          </div></Fade>

          <Fade in={user && !user.emailVerified} unmountOnExit={true}>
            <center>
              <h4>Email Verification Needed</h4>
              {user && <p style={{width: 400, marginTop: 10}}>{"You are signed in, but need to verify your email.  Please check your " + user.email + " email and look for one from noreply@ccoapp.firebaseapp.com.  Don't forget to look in your spam folder if you can't find it.  Click 'Done' after you've followed the link in that email."}</p>}
              <div style={{width: 300}}>
                <CCOButton type="white" text={'Resend Email'} onClick={this.resendEmail.bind(this)} />
                <div style={{height: 10}} />
                <CCOButton type="white" text={'Done'} onClick={this.check.bind(this)} />
                <CCOAlert context={this} value="verificationEmailSent" type="info" title="Verification Email Resent" content="It should arrive in a few minutes. If it doesn't, please make sure your email is correct and check your spam folder." />
                <div style={{height: 30}} />
                <p>Can't verify email right now?</p>
                <CCOButton type="white" text='Back to Login' onClick={() => window.firebase.auth().signOut()} />
              </div>
            </center>
          </Fade>
        </center>
      </div>
    );
  }
}

class CCOAlert extends Component {
  render() {
    return (
      <Collapse in={this.props.context.state[this.props.value]}><div>
        <div style={{height: 8}} />
        <Alert bsStyle={this.props.type} onDismiss={() => {
          let obj = {};
          obj[this.props.value] = false;
          this.props.context.setState(obj);
        }}>
          <h4>{this.props.title}</h4>
          <p>{this.props.content}</p>
        </Alert>
      </div></Collapse>
    );
  }
}

export default Login;



/** WEBPACK FOOTER **
 ** ./src/Login.js
 **/